export default __webpack_public_path__ + "static/media/investinet_esign.25e4a4a1.pdf";